var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalOrdersImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 4,
    fill: "#2463AA",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7175 12.7184L19.78 7.82813C19.5412 7.69618 19.2728 7.62697 19 7.62697C18.7272 7.62697 18.4588 7.69618 18.22 7.82813L9.2825 12.7204C9.02726 12.86 8.8142 13.0657 8.66556 13.3158C8.51692 13.5659 8.43816 13.8513 8.4375 14.1423V23.8557C8.43816 24.1466 8.51692 24.4321 8.66556 24.6822C8.8142 24.9323 9.02726 25.1379 9.2825 25.2776L18.22 30.1698C18.4588 30.3018 18.7272 30.371 19 30.371C19.2728 30.371 19.5412 30.3018 19.78 30.1698L28.7175 25.2776C28.9727 25.1379 29.1858 24.9323 29.3344 24.6822C29.4831 24.4321 29.5618 24.1466 29.5625 23.8557V14.1433C29.5624 13.8518 29.4839 13.5658 29.3352 13.3151C29.1865 13.0644 28.9732 12.8583 28.7175 12.7184ZM19 9.25L27.1605 13.7188L24.136 15.3732L15.9755 10.9045L19 9.25ZM19 18.1875L10.8395 13.7188L14.2834 11.8327L22.444 16.3015L19 18.1875ZM27.9375 23.8598L19.8125 28.3072V19.5921L23.0625 17.8137V21.4375C23.0625 21.653 23.1481 21.8597 23.3005 22.012C23.4528 22.1644 23.6595 22.25 23.875 22.25C24.0905 22.25 24.2972 22.1644 24.4495 22.012C24.6019 21.8597 24.6875 21.653 24.6875 21.4375V16.9241L27.9375 15.1457V23.8557V23.8598Z",
    fill: "#2463AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrdersImg);
export default __webpack_public_path__ + "static/media/total-orders-img.384b561f7c566f90ce375ce1fd2dc70c.svg";
export { ForwardRef as ReactComponent };